import { ROUTES } from "shared/const/routes";
import { RouteElement } from "../types";
import { DashboardPage } from "pages/dashboard";
import { AccountPage } from "pages/account";
import { LoginPage } from "pages/auth/login";
import { TopUpPage } from "pages/top-up";
import { ProfilePage } from "pages/profile";
import ForgotPasswordForm from 'pages/reset-password/ui/ResetPasswordPage';
import { ResetPasswordConfirmPage } from "pages/reset-password-confirm";
import CardPage from "pages/card/ui/CardPage";
import { NotificationPage } from 'pages/notifications';
import BlockCardPage from 'pages/block-card';
import { RegistrationPage } from 'pages/auth/registration';
import { ConfirmPhone } from 'pages/auth/confirm-phone';
import { TwoFactorPage } from 'pages/auth/two-factor';
import { ConfirmEmail } from 'pages/auth/confirm-email';

export const nonAuthRoutes: RouteElement[] = [
  { ...ROUTES.LOGIN, element: <LoginPage /> },
  { ...ROUTES.RESET_PASSWORD, element: <ForgotPasswordForm /> },
  { ...ROUTES.RESET_PASSWORD_CONFIRM, element: <ResetPasswordConfirmPage /> },
  { ...ROUTES.SIGN_UP, element: <RegistrationPage /> },
  { ...ROUTES.CONFIRM_EMAIL, element: <ConfirmEmail /> },
  { ...ROUTES.CONFIRM_PHONE, element: <ConfirmPhone /> },
  { ...ROUTES.TWO_FACTOR, element: <TwoFactorPage /> },
  // { ...ROUTES.RESET_PASSWORD, element: <ResetPasswordPage /> },
];

export const authRoutes: RouteElement[] = [
  { ...ROUTES.DASHBOARD, element: <DashboardPage /> },
  { ...ROUTES.ACCOUNT, element: <AccountPage /> },
  { ...ROUTES.TOP_UP, element: <TopUpPage /> },
  { ...ROUTES.CARD, element: <CardPage /> },
  { ...ROUTES.BLOCK_CARD, element: <BlockCardPage /> },
  // { ...ROUTES.CARD_3DS, element: <ResetPasswordPage /> },
  { ...ROUTES.NOTIFICATIONS, element: <NotificationPage /> },
  // { ...ROUTES.CHANGE_PASSWORD, element: <ResetPasswordPage /> },
  // { ...ROUTES.CHANGE_EMAIL, element: <ResetPasswordPage /> },
  // { ...ROUTES.CHANGE_PHONE, element: <ResetPasswordPage /> },
  { ...ROUTES.PROFILE, element: <ProfilePage /> },
  { ...ROUTES.CONFIRM_EMAIL, element: <ConfirmEmail /> },
  { ...ROUTES.CONFIRM_PHONE, element: <ConfirmPhone /> },
  // { ...ROUTES.VERIFICATION, element: <ResetPasswordPage /> },
  // { ...ROUTES.DELETE_ACCOUNT, element: <ResetPasswordPage /> },
];
